<template>
  <div class="add-students">
    <hr class="mt-3 mb-3" />
    <div class="columns is-multiline">
      <div class="column is-12-touch">
        <div class="columns is-multiline">
          <div class="column is-7-desktop is-12-touch">
            <h2 class="step-title subtitle is-2">
              <div class="step-title-number color-is-success">
                2.
              </div>
              <div
                class="step-title-left"
                v-text="$t('organize-course.add-students.add')"
              />
              <div class="step-title-center color-is-success">
                <i class="fa fa-users is-hidden-mobile" aria-hidden="true" />
              </div>
              <div
                class="step-title-right"
                v-text="$t('organize-course.add-students.students')"
              />
            </h2>
          </div>
          <div class="column is-5-desktop is-12-touch">
            <AddFromEmployeesList
              :employees_list="students"
              btn_class="button is-success is-medium is-fullwidth"
            />

            <a
              href="#groups-list"
              class="button is-warning is-medium is-fullwidth is-hidden-desktop mt-1"
              v-text="$t('employee-group.add-from-groups')"
            />
          </div>
        </div>

        <table class="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th>#</th>
              <th v-text="$t('employee-group.list.name')" />
              <th
                class="is-hidden-touch"
                v-text="$t('employee-group.list.email')"
              />
              <th
                class="is-centered"
                v-text="$t('employee-group.list.share-by-ticket')"
              />
              <th
                class="is-centered"
                v-text="$t('employee-group.list.hard-copy-certificate')"
              />
              <th />
            </tr>
          </thead>
          <tr v-for="(student, index) in students" :key="index">
            <td v-text="`${index + 1}.`" />
            <td v-text="student.name" />
            <td class="is-hidden-touch" v-text="student.email" />
            <td class="is-centered">
              <input
                v-model="student.share_by_ticket"
                :disabled="!student.email"
                type="checkbox"
                class="checkbox"
              />
            </td>
            <td class="is-centered">
              <input
                v-model="student.hard_copy_certificate"
                type="checkbox"
                class="checkbox"
              />
            </td>
            <td>
              <button
                class="button is-small is-danger"
                @click="remove(student)"
              >
                <i class="fa fa-remove" />
              </button>
            </td>
          </tr>
          <tfoot v-show="!students.length">
            <tr>
              <th colspan="5" class="is-centered">
                <span
                  class="subtitle is-3 color-is-grey-lighter"
                  v-text="
                    $t('organize-course.add-students.no-students-selected')
                  "
                />
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
      <div
        v-if="groups.length"
        class="column is-3-desktop is-6-tablet is-12-mobile is-relative"
      >
        <div id="groups-list" class="groups-list">
          <div class="columns is-multiline is-centered">
            <div
              v-for="(group, index) in groups"
              :key="index"
              class="column is-12"
            >
              <div class="card">
                <div class="card-content">
                  <p class="title">
                    <span class="color-is-primary">
                      “
                    </span>
                    <span v-text="group.name" />
                    <span class="color-is-primary">
                      ”
                    </span>
                  </p>
                  <p class="subtitle is-right pt-1">
                    <em
                      v-html="
                        $tc(
                          'employee-group.card.employees-count',
                          group.employees_count,
                          { number: group.employees_count },
                        )
                      "
                    />
                  </p>
                </div>
                <footer class="card-footer">
                  <a
                    class="card-footer-item"
                    @click.prevent="showGroupStudents(group)"
                    v-text="$t('employee-group.card.view')"
                  />
                  <a
                    class="card-footer-item color-is-success"
                    @click.prevent="addFromGroup(group)"
                    v-text="$t('employee-group.card.add')"
                  />
                  <a
                    class="card-footer-item color-is-danger"
                    @click.prevent="removeFromGroup(group)"
                  >
                    <i class="fa fa-remove" />
                  </a>
                </footer>
              </div>
            </div>
          </div>

          <div :class="groupStudents.length ? 'is-active' : ''" class="modal">
            <div class="modal-background" @click="hideGroupStudents" />
            <div class="modal-card">
              <header class="modal-card-head">
                <p
                  class="modal-card-title"
                  v-text="$t('organize-course.add-students.modal-title')"
                />
                <button
                  class="delete"
                  aria-label="close"
                  @click="hideGroupStudents"
                />
              </header>
              <section class="modal-card-body">
                <table class="table is-striped is-fullwidth">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th v-text="$t('employee-group.list.name')" />
                      <th v-text="$t('employee-group.list.email')" />
                    </tr>
                  </thead>
                  <tr v-for="(employee, index) in groupStudents" :key="index">
                    <td v-text="`${index + 1}.`" />
                    <td v-text="employee.name" />
                    <td v-text="employee.email" />
                  </tr>
                </table>
              </section>
              <footer class="modal-card-foot">
                <div class="level is-full-width">
                  <div class="level-left" />
                  <div class="level-right">
                    <button
                      class="button"
                      @click="hideGroupStudents"
                      v-text="$t('organize-course.add-students.close-modal')"
                    />
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>

        <div v-if="groups.length > 2" class="arrow bounce">
          <i class="fa fa-angle-down fa-5x" aria-hidden="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { each, find } from 'lodash';
import Api from 'api/employee_groups';
import AddFromEmployeesList from 'components/Employees/Group/AddFromEmployeesList';

export default {
  name: 'AddStudents',

  components: {
    AddFromEmployeesList
  },

  props: {
    assigned_students: { type: Array, default: () => [] }
  },

  data() {
    return {
      api: new Api(),
      students: this.assigned_students,
      groups: [],
      groupStudents: []
    };
  },

  created() {
    VueEventHub.$on('add-employee', this.add);
  },

  mounted() {
    this.load();
  },

  methods: {
    load() {
      this.api.groups().then(groups => {
        this.groups = groups;
      });
    },

    showGroupStudents(group) {
      this.groupStudents = group.employees.data;
    },

    hideGroupStudents() {
      this.groupStudents = [];
    },

    addFromGroup(group) {
      each(group.employees.data, employee => {
        this.add(employee);
      });

      flash(this.$t('organize-course.add-students.students-added'));
    },

    removeFromGroup(group) {
      each(group.employees.data, employee => {
        const student = find(this.students, { id: employee.id });

        if (student) {
          this.students.splice(this.students.indexOf(student), 1);
        }
      });

      VueEventHub.$emit('students-added', this.students);

      flash(this.$t('organize-course.add-students.students-removed'));
    },

    add(employee) {
      const student = {
        id: employee.id,
        name: employee.name,
        email: employee.email,
        share_by_ticket: employee.email ? 0 : 1,
        hard_copy_certificate: false
      };

      if (!find(this.students, student)) {
        this.students.push(student);
      }

      VueEventHub.$emit('students-added', this.students);
      VueEventHub.$emit('employee-added-to-list');
    },

    remove(student) {
      this.students.splice(this.students.indexOf(student), 1);
      VueEventHub.$emit('students-added', this.students);
    }
  }
};
</script>
